import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { Validators } from "@angular/forms";
import { Location } from "@angular/common";
import { MessageService, SelectItem } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { FechasService } from "src/app/services/fechas/fechas";
import { GenericService } from "../../../services/generic/generic.service";
import { siEsNull } from "src/app/config/texto_comprobacion";
import { HttpClient } from "@angular/common/http";
import { UploadService } from "src/app/services/upload/upload.service";
import { handleImageUpload } from "src/app/config/compress_image";
import { url } from "src/app/config/config";
import { log } from "util";
// import { getCountries } from '@countrystatecity/countries';
@Component({
  selector: "app-clientes-create",
  templateUrl: "./clientes-create.component.html",
  styleUrls: ["./clientes-create.component.css"],
})
export class ClientesCreateComponent implements OnInit {
  private readonly api_token =
    "79c26b370546a926c2bf9196bbb6feeaed73ccb7f01ff7b71f3aba4fd1d68daa";

  public countries: SelectItem[] = [{ label: "...", value: null }];
  public provinces: SelectItem[] = [{ label: "...", value: null }];
  public cities: SelectItem[] = [{ label: "...", value: null }];

  private countryList = [];
  private provinceList = [];
  private citiesList = [];

  countrySelected = {};


  public clienteForm: UntypedFormGroup = new UntypedFormGroup({
    nombre: new UntypedFormControl("", Validators.required),
    eliminado: new UntypedFormControl("0"),
    cif: new UntypedFormControl(""),
    direccion: new UntypedFormControl(""),
    cp: new UntypedFormControl(""),
    localidad: new UntypedFormControl(""),
    provincia: new UntypedFormControl(""),
    pais: new UntypedFormControl(""),
    departamento: new UntypedFormControl(""),
    persona_contacto: new UntypedFormControl(""),
    telefono: new UntypedFormControl(""),
    email: new UntypedFormControl(""),
    tipo_precio_facturacion: new UntypedFormControl(""),
    condicion: new UntypedFormControl(""),
    precio_cc_transporte: new UntypedFormControl(""),
    precio_camion_completo: new UntypedFormControl(""),
    titulo_campo_articulo: new UntypedFormControl(""),
    precio_comision_carro: new UntypedFormControl(""),
    archivo1: new UntypedFormControl(""),
    archivo2: new UntypedFormControl(""),
  });

  public database = "clientes";
  public update: boolean = false;
  public id = "";
  public noGrabar: boolean = false;

  public file: File;
  public file2: File;
  public imagePath: any;
  public imgURL: any;
  public imgURL2: any;
  public urlImagen: string = url + "upload/clientes/";
  public showCamera = false;
  public fileName = "imagen.jpg";
  public numberPhoto = 1;
  public tipoPrecio: SelectItem[] = [
    { label: "EXW (P. Amarillo)", value: "EXW (P. Amarillo)" },
    { label: "FCA (EK Neto)", value: "FCA (EK Neto)" },
    { label: "DDP (Precio en casa)", value: "DDP (Precio en casa)" },
  ];

  constructor(
    private location: Location,
    private messageService: MessageService,
    private genericService: GenericService,
    private _fechaService: FechasService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _uploadService: UploadService,
  ) {}

  async ngOnInit(): Promise<void> {
    // this.getCountries()
    //   .toPromise()
    //   .then((resp: any) => {
    //     if (resp != null) {
    //       this.countryList = resp;
    //       for (let i = 0; i < resp.length; i++) {
    //         const element = resp[i];
    //         this.countries.push({
    //           label: element["name"],
    //           value: element["iso2"],
    //         });
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    await this.loadCountries()

    this.route.params.subscribe((data) => {
      if (data.id == undefined) {
        this.iniciar(null);
      } else {
        this.id = data.id;
        this.update = true;
        this.genericService
          .getId(this.id, this.database)
          .toPromise()
          .then((resp: any) => {
            this.iniciar(resp[0]);
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    });
  }

  async iniciar(value: any) {
    const cliente = value;

    if (cliente != null) {
      for (const key in cliente) {
        if (key.localeCompare("id") == 0) {
          continue;
        }

        if (!this.clienteForm.get(key)) {
          continue;
        }

        if (key.includes("fecha")) {
          this.clienteForm
            .get(key)
            ?.patchValue(this._fechaService.fechaUpdate(cliente[key]));
        } else {
          this.clienteForm.get(key)?.patchValue(siEsNull(cliente[key]));
        }
      }

      const pais = siEsNull(cliente["pais"]);
      const provincia = siEsNull(cliente["provincia"]);
      const localidad = siEsNull(cliente["localidad"]);

      await this.loadProvincesByCountryName(pais);

      this.clienteForm.patchValue({
        provincia: provincia,
      });

      await this.loadCitiesByProvinceName(pais, provincia);

      this.clienteForm.patchValue({
        localidad: localidad,
      });
    }
  }

  regresar() {
    this.location.back();
  }

  getCountries() {
    return this.http.get("https://api.countrystatecity.in/v1/countries", {
      headers: {
        "X-CSCAPI-KEY": this.api_token,
      },
    });
  }

  async getProvinces(event: any) {
    const countryName = event?.value;

    this.clienteForm.patchValue({
      provincia: null,
      localidad: null,
    });

    await this.loadProvincesByCountryName(countryName);
  }

  async getCities(event: any) {
    const provinceName = event?.value;
    const countryName = this.clienteForm.get("pais")?.value;

    this.clienteForm.patchValue({
      localidad: null,
    });

    await this.loadCitiesByProvinceName(countryName, provinceName);
  }

  async loadCountries() {
    const resp: any = await this.getCountries().toPromise();

    if (resp != null) {
      this.countryList = resp;

      this.countries = [
        { label: "...", value: null },
        ...resp.map((element: any) => ({
          label: element["name"],
          value: element["name"], // Guardas el nombre en BD
        })),
      ];
    }
  }

  async loadProvincesByCountryName(countryName: string) {
    this.provinces = [{ label: "...", value: null }];
    this.cities = [{ label: "...", value: null }];

    if (!countryName) return;

    const country = this.countryList.find(
      (item: any) => item["name"] === countryName,
    );

    if (!country) return;

    this.countrySelected = country;

    const response: any = await this.http
      .get(
        `https://api.countrystatecity.in/v1/countries/${country["iso2"]}/states`,
        {
          headers: {
            "X-CSCAPI-KEY": this.api_token,
          },
        },
      )
      .toPromise();

    this.provinceList = response;

    this.provinces = [
      { label: "...", value: null },
      ...response.map((element: any) => ({
        label: element["name"],
        value: element["name"], // Guardas el nombre en BD
      })),
    ];
  }

  async loadCitiesByProvinceName(countryName: string, provinceName: string) {
    this.cities = [{ label: "...", value: null }];

    if (!countryName || !provinceName) return;

    const country = this.countryList.find(
      (item: any) => item["name"] === countryName,
    );

    const province = this.provinceList.find(
      (item: any) => item["name"] === provinceName,
    );

    if (!country || !province) return;

    const response: any = await this.http
      .get(
        `https://api.countrystatecity.in/v1/countries/${country["iso2"]}/states/${province["iso2"]}/cities`,
        {
          headers: {
            "X-CSCAPI-KEY": this.api_token,
          },
        },
      )
      .toPromise();

    this.cities = [
      { label: "...", value: null },
      ...response.map((element: any) => ({
        label: element["name"],
        value: element["name"], // Guardas el nombre en BD
      })),
    ];
  }

  onSubmit() {
    this.noGrabar = true;
    let data = [{}];
    data[0]["id"] = this.id || "0";

    for (const key in this.clienteForm.value) {
      data[0][key] = this.clienteForm.value[key];
    }

    if (this.update) {
      this.genericService
        .update(data[0], this.database)
        .toPromise()
        .then((resp: any) => {
          if (this.file != null)
            this.fileUpload(this.file, this.id, "archivo1");
          if (this.file2 != null)
            this.fileUpload(this.file2, this.id, "archivo2");

          this.messageService.add({
            severity: "success",
            summary: "Registro",
            detail: "Registro actualizado correctamente",
          });
          setTimeout(() => {
            this.router.navigate(["/dashboard/clientes"]);
          }, 2000);
        })
        .catch((error) => {
          console.log("error clientes", error);
        });
    } else {
      this.genericService
        .create(data[0], this.database)
        .toPromise()
        .then((resp: any) => {
          data[0]["id"] = resp.id;
          this.id = resp.id;
          this.genericService.update(data[0], this.database).toPromise();

          if (this.file != null)
            this.fileUpload(this.file, this.id, "archivo1");
          if (this.file2 != null)
            this.fileUpload(this.file2, this.id, "archivo2");

          this.messageService.add({
            severity: "success",
            summary: "Registro",
            detail: "Registro creado correctamente",
          });
          setTimeout(() => {
            this.router.navigate(["/dashboard/clientes"]);
          }, 2000);
        })
        .catch((error) => {
          console.log("Error Clientes, error");
        });
    }
  }

  fileUpload(file: File, id: string, name: string) {
    this._uploadService
      .uploadFilesgeneric(file, id, "clientes", "clientes", name)
      .subscribe(
        () => {
          this.messageService.add({
            severity: "info",
            summary: "Imagen",
            detail: "Imagen añadida correctamente",
          });
        },
        (error) => {
          console.error("Error imagen", error);
        },
      );
  }

  async uploadFile(event: any, position: number) {
    if (position === 1) this.file = await this.newPicture(event);
    if (position === 2) this.file2 = await this.newPicture(event);

    const files = event.target.files;
    if (!files || files.length === 0) return;
    if (!files[0].type.match(/image\/*/)) return;

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      if (position === 1) this.imgURL = reader.result;
      if (position === 2) this.imgURL2 = reader.result;
    };
  }

  async newPicture(event: any): Promise<File> {
    return await handleImageUpload(event);
  }

  deleteImagen(numero: number) {
    if (numero === 1) {
      this.imgURL = null;
      this.file = null;
      this.clienteForm.get("archivo1").patchValue("");
    }
    if (numero === 2) {
      this.imgURL2 = null;
      this.file2 = null;
      this.clienteForm.get("archivo2").patchValue("");
    }
  }

  openCamera(numero: number) {
    this.fileName = "imagen" + numero + ".jpg";
    this.numberPhoto = numero;
    this.showCamera = true;
  }

  getImage(event: { base64: string; file: File; numero: number }) {
    if (event.numero === 1) {
      this.imgURL = event.base64;
      this.file = event.file;
    }
    if (event.numero === 2) {
      this.imgURL2 = event.base64;
      this.file2 = event.file;
    }
    this.showCamera = false;
  }

  closeDialog() {
    this.showCamera = false;
  }
}
